import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import {
	decimalNumberMask,
	onlyNumbers
} from "../../utils/admin-utils";

export const paramsPactoRebatesFormConfig = ({ paramsPactoRebates } = {}) => {
	return [
		{
			fields: [
				{
					name: "baselinePeriod",
					label: "Período em meses da baseline *",
					type: "text",
					placeholder: "0",
					defaultValue: onlyNumbers(paramsPactoRebates?.baselinePeriod),
					columns: 4,
					onChange: onlyNumbers
				},
				{
					name: "measurementPeriod",
					label: "Período em meses de apuração *",
					type: "text",
					placeholder: "0",
					defaultValue: onlyNumbers(paramsPactoRebates?.measurementPeriod),
					columns: 4,
					onChange: onlyNumbers
				},
				{
					name: "minimumNetSalesBaselineValue",
					label: "Valor mínimo da baseline de Net Sales *",
					type: "text",
					placeholder: "R$ 0,00",
					defaultValue: paramsPactoRebates?.minimumNetSalesBaselineValue !== undefined &&
						paramsPactoRebates?.minimumNetSalesBaselineValue !== null
							? MonetaryUtils.formatCurrency(paramsPactoRebates.minimumNetSalesBaselineValue)
							: "",
					columns: 4,
					onChange: value => MonetaryUtils.formatCurrency(value, { fromCents: true })
				},
				{
					name: "netSalesToGrossSalesConversionIndex",
					label: "Índice de conversão de Net Sales para Gross Sales *",
					type: "text",
					placeholder: "1,65",
					defaultValue: decimalNumberMask(
						paramsPactoRebates?.netSalesToGrossSalesConversionIndex,
						2
					),
					columns: 4,
					onChange: value => decimalNumberMask(value, 2)
				},
				{
					name: "gracePeriodPaymentPercentageSum",
					label: "Soma do % de pagamento no período de carência *",
					type: "text",
					placeholder: "0",
					defaultValue: decimalNumberMask(
						paramsPactoRebates?.gracePeriodPaymentPercentageSum,
						1
					),
					columns: 4,
					onChange: value => decimalNumberMask(value, 1)
				},
                {
					name: "numberOfInstallmentsForCalculationBase",
					label: "Quantidade de parcelas para base de cálculo *",
					type: "text",
					placeholder: "0",
					defaultValue: onlyNumbers(
						paramsPactoRebates?.numberOfInstallmentsForCalculationBase
					),
					columns: 4,
					onChange: onlyNumbers
				},
				{
					name: "installmentsAdjustmentPercentage",
					label: "Percentual de reajuste nas parcelas *",
					type: "text",
					placeholder: "0",
					defaultValue: decimalNumberMask(
						paramsPactoRebates?.installmentsAdjustmentPercentage,
						1
					),
					columns: 6,
					onChange: value => decimalNumberMask(value, 1)
				},
				{
					name: "simulatorDisclaimer",
					label: "Disclaimer do Simulador do Pacto *",
					type: "textarea",
					placeholder: "Digite o texto do disclaimer exibido no Simulador do Pacto...",
					defaultValue: paramsPactoRebates?.simulatorDisclaimer || "",
					columns: 12,
					rows: 6,
                    maxLength: 5000
				}
			]
		}
	];
};